export const getFromLocalStorage = (key) => localStorage.getItem(key)

export const setLocalStorage = (key, value) => localStorage.setItem(key, value)

export const removeFromLocalStorage = (key) => localStorage.removeItem(key)

export const getFromSessionStorage = (key) => sessionStorage.getItem(key)

export const setSessionStorage = (key, value) => sessionStorage.setItem(key, value)